// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__IgZMd","header":"MergedInvoice_header__1Z0dw"};